/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setBrandOrderingConfiguration} from '../api'

export const useMutationSetBrandOrderingConfiguration = createReactQueryMutationHook('setBrandOrderingConfiguration', setBrandOrderingConfiguration)
